import { render, staticRenderFns } from "./PatientCall.vue?vue&type=template&id=22b457e6&scoped=true&"
import script from "./PatientCall.vue?vue&type=script&lang=js&"
export * from "./PatientCall.vue?vue&type=script&lang=js&"
import style0 from "./PatientCall.vue?vue&type=style&index=0&id=22b457e6&prod&lang=scss&scoped=true&"
import style1 from "./PatientCall.vue?vue&type=style&index=1&id=22b457e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b457e6",
  null
  
)

export default component.exports